// Version : 0.0.1
// Author : AGALYA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:06-08-2025
import FunderActionTypes from './funder.types';

/** ***************** ADD FUNDER DETAILS START *********************** */
export const addFunderStart = (addData: any) => ({
	type: FunderActionTypes.ADD_FUNDER_START,
	payload: addData,
});

/** ***************** ADD FUNDER DETAILS SUCCESS *********************** */
export const addFunderSuccess = (successData: any) => ({
	type: FunderActionTypes.ADD_FUNDER_SUCCESS,
	payload: successData,
});

/** ***************** ADD FUNDER DETAILS FAILURE *********************** */
export const addFunderFailure = (failureData: any) => ({
	type: FunderActionTypes.ADD_FUNDER_FAILURE,
	payload: failureData,
});

/** ***************** ADD FUNDER DETAILS RESPONSE RESET START *********************** */
export const addFunderResponseResetStart = () => ({
	type: FunderActionTypes.ADD_FUNDER_RESPONSE_RESET,
});

/** ***************** ADD FUNDER DETAILS RESPONSE CHANGED *********************** */
export const addFunderResponseChanged = () => ({
	type: FunderActionTypes.ADD_FUNDER_RESPONSE_CHANGED,
});

/** ***************** ADD FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER DETAILS START *********************** */
export const updateFunderStart = (updateData: any) => ({
	type: FunderActionTypes.UPDATE_FUNDER_START,
	payload: updateData,
});

/** ***************** UPDATE FUNDER DETAILS SUCCESS *********************** */
export const updateFunderSuccess = (successData: any) => ({
	type: FunderActionTypes.UPDATE_FUNDER_SUCCESS,
	payload: successData,
});

/** ***************** UPDATE FUNDER DETAILS FAILURE *********************** */
export const updateFunderFailure = (failureData: any) => ({
	type: FunderActionTypes.UPDATE_FUNDER_FAILURE,
	payload: failureData,
});

/** ***************** UPDATE FUNDER DETAILS RESPONSE RESET START *********************** */
export const updateFunderResponseResetStart = () => ({
	type: FunderActionTypes.UPDATE_FUNDER_RESPONSE_RESET,
});

/** ***************** UPDATE FUNDER DETAILS RESPONSE CHANGED *********************** */
export const updateFunderResponseChanged = () => ({
	type: FunderActionTypes.UPDATE_FUNDER_RESPONSE_CHANGED,
});
/** ***************** UPDATE FUNDER DETAILS END *********************** */

/** ***************** GET FUNDER LIST START *********************** */
export const getFunderListStart = (getData: any) => ({
	type: FunderActionTypes.GET_FUNDER_LIST_START,
	payload: getData,
});

/** ***************** GET FUNDER LIST SUCCESS *********************** */
export const getFunderListSuccess = (successData: any) => ({
	type: FunderActionTypes.GET_FUNDER_LIST_SUCCESS,
	payload: successData,
});

/** ***************** GET FUNDER LIST FAILURE *********************** */
export const getFunderListFailure = (failureData: any) => ({
	type: FunderActionTypes.GET_FUNDER_LIST_FAILURE,
	payload: failureData,
});

/** ***************** GET FUNDER LIST RESPONSE RESET START *********************** */
export const getFunderListResponseResetStart = () => ({
	type: FunderActionTypes.GET_FUNDER_LIST_RESPONSE_RESET,
});

/** ***************** GET FUNDER LIST RESPONSE CHANGED *********************** */
export const getFunderListResponseChanged = () => ({
	type: FunderActionTypes.GET_FUNDER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET FUNDER LIST END *********************** */

/** ***************** FETCH FUNDER DETAILS START *********************** */
export const fetchFunderStart = (fetchData: any) => ({
	type: FunderActionTypes.FETCH_FUNDER_START,
	payload: fetchData,
});

/** ***************** FETCH FUNDER DETAILS SUCCESS *********************** */
export const fetchFunderSuccess = (successData: any) => ({
	type: FunderActionTypes.FETCH_FUNDER_SUCCESS,
	payload: successData,
});

/** ***************** FETCH FUNDER DETAILS FAILURE *********************** */
export const fetchFunderFailure = (failureData: any) => ({
	type: FunderActionTypes.FETCH_FUNDER_FAILURE,
	payload: failureData,
});

/** ***************** FETCH FUNDER DETAILS RESPONSE RESET START *********************** */
export const fetchFunderResponseResetStart = () => ({
	type: FunderActionTypes.FETCH_FUNDER_RESPONSE_RESET,
});

/** ***************** FETCH FUNDER DETAILS RESPONSE CHANGED *********************** */
export const fetchFunderResponseChanged = () => ({
	type: FunderActionTypes.FETCH_FUNDER_RESPONSE_CHANGED,
});
/** ***************** FETCH FUNDER DETAILS END *********************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const deleteFunderStart = (deleteData: any) => ({
	type: FunderActionTypes.DELETE_FUNDER_START,
	payload: deleteData,
});

/** ***************** DELETE FUNDER DETAILS SUCCESS *********************** */
export const deleteFunderSuccess = (successData: any) => ({
	type: FunderActionTypes.DELETE_FUNDER_SUCCESS,
	payload: successData,
});

/** ***************** DELETE FUNDER DETAILS FAILURE *********************** */
export const deleteFunderFailure = (failureData: any) => ({
	type: FunderActionTypes.DELETE_FUNDER_FAILURE,
	payload: failureData,
});

/** ***************** DELETE FUNDER DETAILS RESPONSE RESET START *********************** */
export const deleteFunderResponseResetStart = () => ({
	type: FunderActionTypes.DELETE_FUNDER_RESPONSE_RESET,
});

/** ***************** DELETE FUNDER DETAILS RESPONSE CHANGED  *********************** */
export const deleteFunderResponseChanged = () => ({
	type: FunderActionTypes.DELETE_FUNDER_RESPONSE_CHANGED,
});
/** ***************** DELETE FUNDER DETAILS END *********************** */

/** ***************** PUBLISH FUNDER DETAILS START *********************** */
export const updateIsPublishFunderStart = (publishData: any) => ({
	type: FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_START,
	payload: publishData,
});

/** ***************** PUBLISH FUNDER DETAILS SUCCESS *********************** */
export const updateIsPublishFunderSuccess = (successData: any) => ({
	type: FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_SUCCESS,
	payload: successData,
});

/** ***************** PUBLISH FUNDER DETAILS FAILURE *********************** */
export const updateIsPublishFunderFailure = (failureData: any) => ({
	type: FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_FAILURE,
	payload: failureData,
});

/** ***************** PUBLISH FUNDER DETAILS RESPONSE RESET START *********************** */
export const updateIsPublishFunderResponseResetStart = () => ({
	type: FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_RESPONSE_RESET,
});

/** ***************** PUBLISH FUNDER DETAILS RESPONSE CHANGED *********************** */
export const updateIsPublishFunderResponseChanged = () => ({
	type: FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_RESPONSE_CHANGED,
});
/** ***************** PUBLISH FUNDER DETAILS END *********************** */
